import {
  type AppError,
  ErrorCode,
  ErrorMessage,
  INFO_CODES,
  WARNING_CODES,
  ERROR_CODES,
} from '@imprivata-cloud/authn';

import {
  DEFAULT_BANNER_STATUS,
  type NOTIF_BANNER_TYPE,
} from '@imprivata-cloud/components';

// TODO: Normalize into Error codes
export const IGNORED_ERROR_MESSAGES: Array<ErrorMessage | string> = [
  ErrorMessage.INCORRECT_TENANT_ID,
  ErrorMessage.NOT_ENROLLED_CARD,
];

export const IGNORED_ERROR_CODES: Array<ErrorCode> = [
  ErrorCode.LOW_QUALITY,
  ErrorCode.NO_FACE_DETECTED,
  ErrorCode.FACE_LIMIT,
  ErrorCode.DUPLICATE,
];
export const mapErrorToStatus = (error: AppError): NOTIF_BANNER_TYPE => {
  const { code } = error;
  if (!code) {
    return DEFAULT_BANNER_STATUS;
  }

  if (INFO_CODES.includes(code)) {
    return 'info';
  }

  if (WARNING_CODES.includes(code)) {
    return 'warning';
  }

  if (ERROR_CODES.includes(code)) {
    return 'error';
  }

  return DEFAULT_BANNER_STATUS;
};
